export class WorkspaceCryptoError extends Error {
}
export class PendingMemberError extends WorkspaceCryptoError {
    constructor() {
        super('The user still has pending invitation to accept');
    }
}
export class PrincipalNotFoundError extends WorkspaceCryptoError {
    constructor(params) {
        super(`No principal with id "${params.principalId}" was found`);
    }
}
export class PrincipalTypeMismatchError extends WorkspaceCryptoError {
    constructor(params) {
        super(`Principal with id "${params.principalId}"  has wrong type "${params.actual}" while it was expected to be "${params.expected}"`);
    }
}
export class InvalidCryptoError extends WorkspaceCryptoError {
    constructor(additionalInfo) {
        super(`Invalid crypto! ${additionalInfo ?? ''}`.trim());
    }
}
